import AutoAbstractField from "./AutoAbstractField.mjs";
import {Button, ButtonGroup} from "reactstrap";

const AutoButtonsField = class extends AutoAbstractField {
	constructor(props) {
		super(props);
		this.state.options = (props.def.options||props.def.buttons||[])
			.map( b => {
				if ( typeof b !== 'object' ) b = { value: b };
				if ( ! b.label ) b.label = String(b.value);
				return b;
			});
		this.makeButton = this.makeButton.bind(this);
	}

	makeButton(opt,idx) {
		const active = this.state.value === opt.value;
		let icon;
		if ( active && opt.iconActive ) {
			icon = opt.iconActive;
		} else if ( ! active && opt.iconInactive ) {
			icon = opt.iconInactive;
		} else if ( opt.icon ) {
			icon = opt.icon;
		}
		const iconAfter = (icon && idx === 1 && this.state.options.length === 2);
		const iconBefore = ( icon && ! iconAfter );
		return (
			<Button
				key={String(idx) + this.state.value}
				active={active}
				onClick={() => {
					if (active) {
						this.setValue();
					} else {
						this.setValue(opt.value);
					}
				}}
			>
				{iconBefore && <i>{icon}</i>}
				<b>{opt.label}</b>
				{iconAfter && <i>{icon}</i>}
			</Button>
		)
	}

	renderField() {
		return(
			<ButtonGroup
				className={"btn-icon AutoButtons"}
				vertical={ this.state.options.length > 3 }
			>
				{ this.state.options.map( this.makeButton ) }
			</ButtonGroup>
		)
	}
}

export default AutoButtonsField;
